import { createAsyncThunk } from "@reduxjs/toolkit";
import { toast } from "../../components/app-toast";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { APP_PATH } from "../../api/backendPath";
import { ACTIONS_CALCULATE_CLAIM } from "../../action-types/actions";

export const calculateClaim = createAsyncThunk(
  ACTIONS_CALCULATE_CLAIM.calculateClaim,
  async ({ claimId }, { rejectWithValue }) => {
    const axiosPrivate = await useAxiosPrivate();

    try {
      const response = await axiosPrivate.post(
        `${process.env.REACT_APP_API_URL}${APP_PATH.calculateClaim.replace(
          "{claimId}",
          claimId,
        )}`,
      );

      if (response?.data?.status === true || response?.status === 200) {
        toast.success("Claim calculated successfully");
        return response.data;
      } else {
        toast.error(response?.data?.message || "Failed to calculate claim");
        return rejectWithValue(response.data);
      }
    } catch (error) {
      console.error("Calculate claim error:", error);
      const errMsg =
        error?.response?.data?.message ||
        "Something went wrong while calculating claim";
      toast.error(errMsg);
      return rejectWithValue(errMsg);
    }
  },
);
